/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useLocation } from "react-router-dom";
import { GetGroupSlots } from "../../../utilities/api/associateBooking";
import { AssociateRescheduleAddMoreDaysModal } from "./AssociateRescheduleAddMoreDaysModal";
import { AssociateRescheduleEditModal } from "./AssociateRescheduleEditModal";
import { AssociateRescheduleCancelModal } from "./AssociateRescheduleCancelModal";
import { AssociateRescheduleEndDateModal } from "./AssociateRescheduleEndDateModal";
import { images } from "../../../config/images";

const AssociateBookingReschedule = () => {
    const bookingDetails = useLocation().state;
    const [slots, setSlots] = useState<any>([])
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showEndDateModal, setShowEndDateModal] = useState(false);
    const [editSlotData, setEditSlotData] = useState<any>({})
    const [cancelPayload, setCancelPayload] = useState({
        cancelType: "daywiseOuter",
        bookingDay: "",
        startTime: "",
        endTime: "",
        slotId: ""
    })

    const StartDate = () => {
        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        nextMonth.setDate(1);
        const formattedStartDate = `${String(nextMonth.getDate()).padStart(2, '0')}/${String(nextMonth.getMonth() + 1).padStart(2, '0')}/${nextMonth.getFullYear()}`;
        return formattedStartDate
    }

    const handleCloseAdd = () => setShowAddModal(false);
    const handleCloseEdit = () => setShowEditModal(false);
    const handleCloseCancel = () => setShowCancelModal(false);
    const handleCloseEndDate = () => setShowEndDateModal(false);

    const handleShowAdd = () => setShowAddModal(true);
    const handleShowEdit = (item: any) => {
        setEditSlotData(item)
        setShowEditModal(true)
    };

    const handleShowEndDate = () => setShowEndDateModal(true);

    const handleShowCancel = (item: any) => {
        setCancelPayload({
            ...cancelPayload,
            bookingDay: item.bookingDay,
            startTime: item.startTime,
            endTime: item.endTime,
        })
        setShowCancelModal(true)
    };



    const GetData = async () => {
        const _slots = await GetGroupSlots(bookingDetails.id, "true")
        if (_slots.statusCode === 200) {
            let data = [] as any
            _slots.data.forEach((item: any) => {
                item.list.forEach((elem: any) => {
                    data.push(elem)
                })
            })
            setSlots(data)
        }
    };

    useEffect(() => {
        GetData();
    }, []);

    return (
        <>
            <Container fluid className="g-0">
                <Card>
                    <Card.Body>
                        <div className="page-title align-items-center d-flex justify-content-between">
                            <Card.Title className="mb-0">Reschedule Associate Booking</Card.Title>
                        </div>
                        <hr />

                        <Row className="text-start align-items-center row-mb">
                            <Col lg={6}>
                                <div className="fw-semibold mb-3">Booking Start Date: <span className="text-info">{bookingDetails?.startDate}</span>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="align-items-center d-flex fw-semibold mb-3">Booking End Date:{" "}<span className="text-info">{bookingDetails?.endDate}</span>{" "}
                                    <img
                                        className="btn border-0"
                                        style={{ width: "8%" }}
                                        src={images.updateicon.default}
                                        onClick={(e) => {
                                            e?.stopPropagation();
                                            handleShowEndDate();
                                        }}
                                        alt="Edit"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="text-start">

                                    {slots?.map((item: any, index: number) => {
                                        return (
                                            <Card className="bg-light bg-opacity-25 border-left-5 border-light mb-3" key={'slots' + index}>
                                                <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                                                    <div className="date-range fw-semibold  w-25">{item.bookingDay}</div>
                                                    <div className="time-slot fw-semibold  w-25">{item.startTime} to {item.endTime}</div>
                                                    <div className="date-range fw-semibold  w-25">{item.combinedCourts?.map((elem: any, index: number) => index !== (item.combinedCourts?.length - 1) ? `${elem.courtName}, ` : elem.courtName)}</div>
                                                    <div className="w-25 text-end">
                                                        <Button type="button" bname="Edit" name="edit-slot" id="edit" onClick={() => handleShowEdit(item)} className="btn btn-sm btn-outline-primary px-4 rounded-1 me-2"></Button>
                                                        <Button type="button" bname="Cancel" name="cancel-slot" id="cancel" onClick={() => handleShowCancel(item)} className="btn btn-sm btn-outline-primary px-4 rounded-1"></Button>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        );
                                    })}
                                </div>
                            </Col>
                        </Row>
                        <Row className="align-items-baseline">
                            {slots?.length ? <>
                                <Col lg={8} className="text-start">
                                    <span className="fs-7 fst-italic fw-semibold text-black text-start"><span className="text-primary">Note</span> : Rescheduling of Slots will be applicable from next Month only.</span>
                                </Col>
                                <Col lg={4} className="text-end mt-3">
                                    <Button type="submit" bname="Add More Days" onClick={handleShowAdd} name="continue" id="continue" className="btn btn-primary px-4 rounded-1"></Button>
                                </Col>
                            </>
                                : <span className="fs-7 fst-italic fw-semibold text-black text-start"><span className="text-primary">Note</span> : Only End Date can be Reschedule, because End Date is in Current Month.</span>
                            }
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
            <AssociateRescheduleEndDateModal showEndDateModal={showEndDateModal} handleCloseEndDate={handleCloseEndDate} EndDate={bookingDetails?.endDate} id={bookingDetails.id} />
            <AssociateRescheduleAddMoreDaysModal showAddModal={showAddModal} handleCloseAdd={handleCloseAdd} GetData={GetData} bookingDetails={bookingDetails} StartDate={StartDate} />
            <AssociateRescheduleEditModal showEditModal={showEditModal} handleCloseEdit={handleCloseEdit} editSlotData={editSlotData} GetData={GetData} bookingDetails={bookingDetails} StartDate={StartDate} />
            <AssociateRescheduleCancelModal showCancelModal={showCancelModal} handleCloseCancel={handleCloseCancel} GetData={GetData} cancelPayload={cancelPayload} setCancelPayload={setCancelPayload} id={bookingDetails.id} />
        </>
    )
}
export { AssociateBookingReschedule }
